import { Listbox, Transition } from "@headlessui/react";
import PropTypes from "prop-types";

import Link from "components/atoms/ButtonNew";

import { FiChevronDown } from "../Icon/fi/FiChevronDown";

const Dropdown = ({
  data,
  children,
  activeIndex,
  labelValue,
  buttonExtendedClass,
  ...props
}) => (
  <Listbox
    {...props}
    as="div"
    className={props.className ? props.className : " dropdown-default"}
    onChange={props.onChange ? props.onChange : () => {}}
  >
    {({ open }) => (
      <>
        <Listbox.Button
          className={`relative w-full select-none pl-4  pr-9 text-left font-medium leading-6 h-full${
            buttonExtendedClass ? ` ${buttonExtendedClass}` : ""
          }`}
        >
          <span className={open ? "text-bbc-brand-700" : "text-bbc-brand-800"}>
            {labelValue && labelValue !== "" ? labelValue : activeIndex}
          </span>
          <FiChevronDown
            className={`absolute right-4 top-1/2 float-right -translate-y-1/2 transform align-middle text-bbc-brand-500  ${
              open ? "rotate-180" : "rotate-0"
            } transition-all duration-200`}
            size={20}
          />
        </Listbox.Button>
        <Transition
          leave="transition-all duration-200 ease-out"
          leaveFrom="transform  opacity-50"
          leaveTo="transform  opacity-0"
        >
          <Listbox.Options
            className={`absolute z-10 mt-1 w-full select-none ${props.optionsClass}`}
            style={props.optionsStyle}
            as="div"
          >
            {children ? (
              children
            ) : (
              <div className=" rounded-b-xl  bg-white pb-2">
                {Array.isArray(data) &&
                  data.map((item, index) => {
                    if (item.title != activeIndex) {
                      return (
                        <Listbox.Option
                          key={index}
                          value={item.uri}
                          as="div"
                          className="block cursor-pointer"
                        >
                          <Link
                            as="a"
                            variant={"ghost"}
                            href={item.uri}
                            useRouter
                            btnDisplay="block"
                            btnTextColor="text-bbc-brand-700 hover:text-bbc-brand-500"
                            btnPadding="px-4 py-2"
                            btnTextWeight="font-normal"
                          >
                            {item.title}
                          </Link>
                        </Listbox.Option>
                      );
                    }

                    return <></>;
                  })}
              </div>
            )}
          </Listbox.Options>
        </Transition>
      </>
    )}
  </Listbox>
);

export default Dropdown;

Dropdown.propTypes = {
  labelValue: PropTypes.any,
  data: PropTypes.array,
  children: PropTypes.element,
  buttonExtendedClass: PropTypes.string,
  activeIndex: PropTypes.string,
};

Dropdown.defaultProps = {
  labelValue: null,
  data: [],
  buttonExtendedClass: null,
  activeIndex: "No thing to choose",
};

/** ========== */
